<div class="modal-description">
  <header
    class="
      d-flex
      align-items-center
      justify-content-between
      modal__header
      modal-description__header
    "
  >
    <h2 class="modal__title">Depoimento
      {{
        user.gender == "Mulher Cis" ||
        user.gender == "Mulher Trans"
          ? "da usuária"
          : "do usuário"
      }}</h2>
    <button
      style="border: none; background: none;"
      type="button"
      class="modal-description__close"
      (click)="closeModal()"
    >
    <mat-icon
    style="margin: 0px; padding: 0px"
    color="primary"
    >close</mat-icon
  >
    </button>
  </header>
  <div class="modal__body">
    <p class="p modal-description__text">
      {{
        denounce.description?.length == 0
          ? "Desculpa, não temos depoimentos registradas dessa denúncia."
          : denounce.description
      }}
    </p>
  </div>
</div>
